import React from 'react';
import { motion } from 'framer-motion';
import { complianceLayers } from '../../data/mockData';

const statusColors = {
  LOCAL: 'text-cyan-400 bg-cyan-500/10 border-cyan-500/30',
  VERIFIED: 'text-emerald-400 bg-emerald-500/10 border-emerald-500/30',
  ACTIVE: 'text-amber-400 bg-amber-500/10 border-amber-500/30',
  READY: 'text-fuchsia-400 bg-fuchsia-500/10 border-fuchsia-500/30',
  PENDING: 'text-zinc-500 bg-zinc-800/50 border-zinc-700/50',
};

export default function CompliancePanel() {
  return (
    <div className="bg-zinc-900/30 border border-zinc-800 rounded-lg overflow-hidden">
      <div className="px-5 py-3 border-b border-zinc-800 flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 pulse-dot" />
        <span className="text-[10px] font-mono tracking-widest text-zinc-500 uppercase">
          compliance_matrix.log
        </span>
      </div>
      <div className="divide-y divide-zinc-800/50">
        {complianceLayers.map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.1 }}
            className="flex items-center justify-between px-5 py-3 hover:bg-zinc-900/50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <span className="text-xs font-bold text-zinc-200 w-36">{item.name}</span>
              <span className="text-[10px] text-zinc-600 hidden md:block">{item.detail}</span>
            </div>
            <span className={`text-[9px] font-mono font-bold tracking-widest px-2.5 py-1 rounded border ${statusColors[item.status]}`}>
              {item.status}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  );
}